<template>
  <el-dialog custom-class="with-title" :title="setTitle" :visible.sync="visible" :before-close="close">
    <LotteryPageTable v-if="mode === 'settings'" />
    <LotteryPageWin v-else-if="mode === 'edit_win'" />
    <LotteryPageLose v-else />
  </el-dialog>
</template>
<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import LotteryPageLose from '@/client/features/twitter_applicant/lottery_page_lose'
import LotteryPageTable from '@/client/features/twitter_applicant/lottery_page_table'
import LotteryPageWin from '@/client/features/twitter_applicant/lottery_page_win'
import { useLotteryPageSettingDialogStore } from '@/client/store/useLotteryPageSettingDialogStore'

export default defineComponent({
  name: 'LotteryPageDialog',
  components: {
    LotteryPageTable,
    LotteryPageLose,
    LotteryPageWin
  },
  data() {
    return {
      visible: false,
      title: '当落選ページの管理'
    }
  },
  computed: {
    ...mapState(useLotteryPageSettingDialogStore, ['lotteryPages', 'mode']),
    setTitle(): string {
      switch (this.mode) {
        case 'settings':
          return '当落選ページの管理'
        case 'create':
          return '落選ページの作成'
        case 'edit_win':
          return '当選ページの編集'
        case 'edit_lose':
          return '落選ページの編集'
        case 'copy':
          return '落選ページの複製'
        default:
          return ''
      }
    }
  },

  methods: {
    ...mapActions(useLotteryPageSettingDialogStore, ['fetchLotteryPages', 'reset', 'setParams', 'setMode']),

    /**
     * ダイアログを表示
     */
    async open(campaignId: number, prizeId: number) {
      this.visible = true

      this.setParams({ campaignId, prizeId })
      await this.fetchLotteryPages()
      this.setMode('settings')
    },

    /**
     * ダイアログを閉じる
     */
    close() {
      this.visible = false
      this.reset()
    }
  }
})
</script>
